<template>
  <div class="page-container">
    <aside class="side-nav-fixed">
      <router-link to="/SpecialistGoals" exact-active-class="active-link">
        Milestones
      </router-link>
      <router-link to="/SpecialistGoals" exact-active-class="active-link">
        Support Plans
      </router-link>
      <button
        class="side-nav-btn"
        :class="{ 'active-link': sideView === 'iep' }"
        @click="sideView = sideView === 'iep' ? null : 'iep'; sideView === 'iep' && fetchIEPs()"
      >
        IEP
      </button>
    </aside>

    <div v-if="sideView === 'iep'" class="specialist-goals-child-screening">
      <div class="iep-panel">
        <div class="iep-header">
          <div>
            <h1 class="iep-patient-name" v-if="child">{{ child.first_name }} {{ child.last_name }}</h1>
            <h2>IEP Documents</h2>
          </div>
          <div class="iep-header-actions">
            <button class="download-csv-btn" @click="downloadCSV" :disabled="ieps.length === 0">
              ↓ Download CSV
            </button>
            <label class="upload-btn">
              <input type="file" accept=".pdf" @change="uploadIEP" :disabled="iepUploading" hidden />
              {{ iepUploading ? 'Uploading...' : '+ Upload IEP' }}
            </label>
          </div>
        </div>
        <p v-if="iepError" class="iep-error">{{ iepError }}</p>

        <div v-if="ieps.length === 0 && !iepUploading" class="iep-empty">
          No IEP documents uploaded yet.
        </div>

        <div v-for="iep in ieps" :key="iep.iep_id" class="iep-card">
          <div class="iep-card-header">
            <div class="iep-file-info">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
              <div>
                <p class="iep-filename">{{ iep.file_name }}</p>
                <p class="iep-date">Uploaded {{ formatDate(iep.created_at) }}</p>
              </div>
            </div>
            <button class="iep-delete-btn" @click="deleteIEP(iep.iep_id)">Delete</button>
          </div>

          <div class="iep-parsed">
            <div class="iep-field">
              <span class="iep-label">Eligibility Category</span>
              <span class="iep-value">{{ iep.eligibility_category || 'Not found in document' }}</span>
            </div>
            <div class="iep-field">
              <span class="iep-label">Goals</span>
              <div v-if="iep.goals && iep.goals.length > 0">
                <div v-for="(goal, i) in iep.goals" :key="i" class="iep-goal">
                  <span class="goal-num">{{ i + 1 }}</span>
                  <span>{{ goal }}</span>
                </div>
              </div>
              <span v-else class="iep-value">No goals extracted</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="specialist-goals-child-screening">
      <div class="child-card">
        <div class="top-section">
          <div class="left-info">
            <div class="circle"></div>
            <div class="child-info">
              <h2>{{ child.first_name }} {{ child.last_name }}</h2>
              <p class="details">Age: {{ child.biological_age }} | Grade: {{ child.grade }}</p>
              <p class="details">Last {{activeTab}}: {{analytics &&
    analytics.archived_activities &&
    analytics.archived_activities.length > 0 &&
    analytics.archived_activities[0].finish_date
      ? formatDate(analytics.archived_activities[0].finish_date)
      : 'N/A'}}</p>
              <p class="details">Site Name: {{ child.site_name }}</p>
              <div class="sections">
                <div class="section">
                  <h3> Strengths</h3>
                  <div class="tags">
                    <span
                      v-for="(tag, index) in (analytics && analytics.tags && analytics.tags.strengths) || []"
                      :key="'strength-' + index"
                      class="strength-tag"
                    >
                      {{ tag }}
                    </span>
                  </div>
                </div>
                <div class="section">
                  <h3>Focus Areas</h3>
                  <div class="tags">
                    <span
                      v-for="(tag, index) in (analytics && analytics.tags && analytics.tags.focus) || []"
                      :key="'focus-' + index"
                      class="focus-tag"
                    >
                      {{ tag }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-top-section">
          <div class="tabs">
                <button 
                  :class="{ active: activeTab === 'screening' }"
                  @click="activeTab = 'screening'"
                >Screening/Mini-Test</button>
                <button 
                  :class="{ active: activeTab === 'assessments' }"
                  @click="activeTab = 'assessments'"
                >Assessments</button>

                <button 
                  :class="{ active: activeTab === 'interventions' }"
                  @click="activeTab = 'interventions'"
                >Interventions</button>
            </div>
            <div class="actions">
                <button class="edit-profile">Edit Profile</button>
                <div class="sort-by">
                    <select v-model="area">
                        <option value=""></option>
                        <option value="Cognitive">Cognitive</option>
                        <option value="Motor">Motor</option>
                        <option value="Speech and Language">Speech and Language</option>
                        <option value="Reading and Writing">Reading and Writing</option>
                        <option value="Mental Health">Mental Health</option>
                        <option value="ASD">Autism (ASD)</option>
                        <option value="ADHD">ADHD</option>
                        <option value="Questionnaire">Questionnaire</option>
                        <option value="Other">Other</option>
                    </select>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <div class="stat-card">
        <div v-if="activeTab === 'assessments'" class="assessment-card">
          <div class="assesment-grid">
            <div class="mini-card">
              <h3>Progress Over Time</h3>
              <div class="pill-toggle">
                <button
                  :class="{ active: yearType === 'calendar' }"
                    @click="updateYearType('calendar')"
                >
                Calendar Year
                </button>
                <button
                  :class="{ active: yearType === 'academic' }"
                    @click="updateYearType('academic')"
                >
                School Year
                </button>
              </div>
              <div class="semester-row" v-if="yearType === 'academic'">
                  <button
                    :class="{active: semesterType ==='fall'}"
                      @click="updateSemesterType('fall')"
                  >
                  Fall
                  </button>
                  <button 
                    :class="{active: semesterType ==='spring'}"
                      @click="updateSemesterType('spring')"
                  >
                  Spring
                  </button>
                </div>
                <div class="legend">
                  <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="3" fill="#f6a620" />
                  </svg>
                  <p>2026</p>
                  <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="3" fill="#dc6803" />
                  </svg>
                  <p>2025</p>
                  <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="3" fill="#93370d" />
                  </svg>
                  <p>2024</p>
                </div>
              <div class="progress-over-time">
                  <LineChartThreeECharts
                    :months="analytics.progress_comparison.months"
                    :lastYear="analytics.progress_comparison.last_year"
                    :present="analytics.progress_comparison.this_year"
                    :lastLastYear="analytics.progress_comparison.last_last_year"
                  />
                </div>
            </div>
            <div class="mini-card">
              <h3>Breakdown of Assessments</h3>
              <div class="label">Focus Areas</div>
              <div class="breakdown-container">
                <BarChartEChart2
                  :key="activeTab + '-' + area + '-' + yearType"
                  :data-input="breakdownData"
                  :bar-colors="['#f6a620', '#dc6803', '#93370d']"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="activeTab === 'interventions'" class="intervention-card">
          <div class="intervention-grid">
            <div class="mini-card">
              <h3>Progress Over Time</h3>
              <div class="pill-toggle">
                <button
                  :class="{ active: yearType === 'calendar' }"
                    @click="updateYearType('calendar')"
                >
                Calendar Year
                </button>
                <button
                  :class="{ active: yearType === 'academic' }"
                    @click="updateYearType('academic')"
                >
                School Year
                </button>
              </div>
              <div class="semester-row" v-if="yearType === 'academic'">
                  <button
                    :class="{active: semesterType ==='fall'}"
                      @click="updateSemesterType('fall')"
                  >
                  Fall
                  </button>
                  <button 
                    :class="{active: semesterType ==='spring'}"
                      @click="updateSemesterType('spring')"
                  >
                  Spring
                  </button>
                </div>
                <div class="legend">
                  <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="3" fill="#ff92ae" />
                  </svg>
                  <p>Target Goal</p>
                  <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="3" fill="#65e9f0" />
                  </svg>
                  <p>Patient Progress</p>
                </div>
              <div class="progress-over-time">
                  <LineChartGroupedECharts
                    :months="analytics.progress_comparison.months"
                    :lastYear="analytics.progress_comparison.last_year"
                    :present="analytics.progress_comparison.this_year"
                  />
                </div>
            </div>
            <div class="mini-card">
              <h3>Breakdown of Interventions</h3>
              <div class="label">Focus Areas</div>
              <div class="breakdown-container">
                <BarChartEChart2
                  :key="activeTab + '-' + area + '-' + yearType"
                  :data-input="breakdownData"
                  :bar-colors="['#f6a620', '#dc6803', '#93370d', '#f6a620', '#dc6803', '#93370d']"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="activeTab === 'screening'" class="screening-card">
          <div class="screening-grid">
            <div class="mini-card">
              <div class="screening-header">
              <h3>Screening Statistics</h3>
                </div>
                <div class="stats-grid">
                  <!-- Stat 1 -->
                  <div class="stat-item">
                    <div class="icon-box">
                      <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="46" height="46" fill="none" stroke="black" stroke-width="3" rx="6" />
                                    <rect x="10" y="25" width="5" height="15" fill="#000" stroke="#000" stroke-width="0.75"  />
                                    <rect x="22" y="15" width="5" height="5" fill="#000" stroke="#000" stroke-width="0.75"  />
                                    <rect x="22" y="25" width="5" height="15" fill="#000" stroke="#000" stroke-width="0.75"  />
                                    <rect x="34" y="10" width="5" height="30" fill="#000" stroke="#000" stroke-width="0.75"  />
                                  </svg>
                    </div>
                    <div class="stat-text">
                      <div class="stat-number">{{ analytics.statistics.total_screening }}</div>
                      <div class="stat-label">Total Screenings</div>
                      <div class="stat-subtext positive">+{{ analytics.statistics.monthly_screening }} this month</div>
                    </div>
                  </div>

                  <!-- Stat 2 -->
                  <div class="stat-item">
                    <div class="icon-box">
                      <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="46" height="46" fill="none" stroke="black" stroke-width="3" rx="6" />
                                    <rect x="15" y="10" width="20" height="20" fill="none" stroke="#000000" stroke-width="2" rx="20"/>
                                    <line x1="23" y1="25" x2="30" y2="15" style="stroke:black;stroke-width:2" />
                                    <line x1="19" y1="20" x2="24" y2="25" style="stroke:black;stroke-width:2" />
                                    <line x1="30" y1="29" x2="35" y2="38" style="stroke:black;stroke-width:2" />
                                    <line x1="25" y1="34" x2="35" y2="38" style="stroke:black;stroke-width:2" />
                                    <line x1="15" y1="38" x2="25" y2="34" style="stroke:black;stroke-width:2" />
                                    <line x1="20" y1="29" x2="15" y2="38" style="stroke:black;stroke-width:2" />
                                  </svg>
                    </div>
                    <div class="stat-text">
                      <div class="stat-number">{{ analytics.statistics.average_score }}</div>
                      <div class="stat-label">Average Score (%)</div>
                      <div class="stat-subtext">Out of 100</div>
                    </div>
                  </div>

                  <!-- Stat 3 -->
                  <div class="stat-item">
                    <div class="icon-box">
                      <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="46" height="46" fill="none" stroke="black" stroke-width="3" rx="6" />
                                    <rect x="15" y="15" width="20" height="20" fill="none" stroke="#000000" stroke-width="2" rx="20"/>
                                    <rect x="21.75" y="11" width="7" height="2" fill="#000000" stroke-width="1"/>
                                    <line x1="33" y1="18" x2="35" y2="16" style="stroke:black;stroke-width:2" />
                                    <path x="15" y="15" width="15" height="15" fill="none" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M16 25 h4 l2-4 l3 8 l2-4 h7" />
                                  </svg>
                    </div>
                    <div class="stat-text">
                      <div class="stat-number">{{ analytics.statistics.average_duration }}</div>
                      <div class="stat-label">Average Duration (min)</div>
                      <div class="stat-subtext">Per Screening</div>
                    </div>
                  </div>
                  <!-- Stat 4 -->
                  <div class="stat-item">
                    <div class="icon-box">
                      <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="46" height="46" fill="none" stroke="black" stroke-width="3" rx="6" />
                                    <rect x="12.5" y="15" width="25" height="25" fill="none" stroke="black" stroke-width="2" rx="4" />
                                    <rect x="24" y="12" width="3" height="3" fill="none" stroke="black" stroke-width="1.5" rx="2" />
                                    <rect x="16" y="20" width="17.5" height="2" fill="black" strokr-width="1.5" />
                                    <rect x="16" y="26" width="17.5" height="2" fill="black" strokr-width="1.5" />
                                    <rect x="16" y="32" width="10.5" height="2" fill="black" strokr-width="1.5" />
                                  </svg>
                    </div>
                    <div class="stat-text">
                      <div class="stat-number">{{ analytics.statistics.monthly_screening }}</div>
                      <div class="stat-label">Mini-Tests this Month</div>
                      <div class="stat-subtext link">2 Recommended</div>
                    </div>
                  </div>
                </div>
              </div>
            <div class="mini-card">
              <h3>Progress Over Time</h3>
              <div class="pill-toggle">
                <button
                  :class="{ active: yearType === 'calendar' }"
                    @click="updateYearType('calendar')"
                >
                Calendar Year
                </button>
                <button
                  :class="{ active: yearType === 'academic' }"
                    @click="updateYearType('academic')"
                >
                School Year
                </button>
              </div>
              <div class="semester-row" v-if="yearType === 'academic'">
                  <button
                    :class="{active: semesterType ==='fall'}"
                      @click="updateSemesterType('fall')"
                  >
                  Fall
                  </button>
                  <button 
                    :class="{active: semesterType ==='spring'}"
                      @click="updateSemesterType('spring')"
                  >
                  Spring
                  </button>
                </div>
                <div class="legend">
                  <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="3" fill="#f6a620" />
                  </svg>
                  <p>2026</p>
                  <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="3" fill="#dc6803" />
                  </svg>
                  <p>2025</p>
                  <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="3" fill="#93370d" />
                  </svg>
                  <p>2024</p>
                </div>
                <div class="progress-over-time">
                  <LineChartThreeECharts
                    :months="analytics.progress_comparison.months"
                    :lastYear="analytics.progress_comparison.last_year"
                    :present="analytics.progress_comparison.this_year"
                    :lastLastYear="analytics.progress_comparison.last_last_year"
                  />
                </div>
            </div>
            <div class="mini-card">
              <h3>Breakdown of Screenings</h3>
              <div class="label">Focus Areas</div>
              <div class="breakdown-container">
                <BarChartEChart2
                  :key="activeTab + '-' + area + '-' + yearType"
                  :data-input="breakdownData"
                  :bar-colors="['#f6a620', '#dc6803', '#93370d']"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="info-card-wrapper">
        <div v-if="activeTab === 'assessments'" class="activity-information-card">
          <h4>Assessments</h4>
          <div class="activity-scroll">
          <table class="activity-table">
            <thead>
              <tr>
                <th @click="toggleSort('start')">Start Date</th>
                <th @click="toggleSort('type')">Type</th>
                <th @click="toggleSort('score')">Score</th>
                <th @click="toggleSort('outcome')">Outcome</th>
                <th @click="toggleSort('category')">Weakest Areas</th>
              </tr>
            </thead>
            <tbody>
                <template v-if="analytics && analytics.archived_activities && analytics.archived_activities.length > 0">
                  <tr v-for="activity in analytics.archived_activities" :key="activity.start_date">
                    <td>{{ formatDate(activity.start_date) }}</td>
                    <td><span class="type">{{ activity.type }}</span></td>
                    <td>{{ activity.score }}%</td>
                    <td>{{ activity.outcome }}</td>
                    <td><span v-for="pair in pairCategories(activity)" :key="pair.name" class="category">{{ pair.name }} | Score: {{ pair.score }}</span></td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td>0/0/0000</td>
                    <td><span class="type">N/A</span></td>
                    <td>0%</td>
                    <td>N/A</td>
                    <td>N/A | Score: 0</td>
                  </tr>
                </template>
              </tbody>
          </table>
          </div>
        </div>
        <div v-else-if="activeTab === 'interventions'" class="activity-information-card">
          <h4>Intervention</h4>
          <div class="activity-scroll">
          <table class="activity-table">
            <thead>
              <tr>
                <th @click="toggleSort('start')">Start Date</th>
                <th @click="toggleSort('finish')">End Date</th>
                <th @click="toggleSort('type')">Type</th>
                <th @click="toggleSort('progress')">Progress</th>
                <th @click="toggleSort('category')">Weakest Areas</th>
              </tr>
            </thead>
            <tbody>
                  <template v-if="analytics && analytics.archived_activities && analytics.archived_activities.length > 0">
                    <tr v-for="activity in analytics.archived_activities" :key="activity.start_date">
                      <td>{{ formatDate(activity.start_date) }}</td>
                      <td>{{ formatDate(activity.finish_date) }}</td>
                      <td><span class="type">{{ activity.type }}</span></td>
                      <td>{{ activity.progress }}</td>
                      <td><span v-for="pair in pairCategories(activity)" :key="pair.name" class="category">{{ pair.name }} | Score: {{ pair.score }}</span></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td>0/0/0000</td>
                      <td>0/0/0000</td>
                      <td>N/A</td>
                      <td>N/A</td>
                      <td>N/A | Score: 0</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
        </div>
        <div v-else-if="activeTab === 'screening'" class="activity-information-card">
          <h4>Screening/Mini-Test</h4>
          <div class="activity-scroll">
          <table class="activity-table">
            <thead>
              <tr>
                <th @click="toggleSort('start')">Start Date</th>
                <th @click="toggleSort('type')">Type</th>
                <th @click="toggleSort('duration')">Duration</th>
                <th @click="toggleSort('score')">Score</th>
                <th @click="toggleSort('outcome')">Outcome</th>
                <th @click="toggleSort('category')">Categories/Skills Tested</th>
              </tr>
            </thead>
                <tbody>
                  <template v-if="analytics && analytics.archived_activities && analytics.archived_activities.length > 0">
                    <tr v-for="activity in analytics.archived_activities" :key="activity.start_date">
                      <td>{{ formatDate(activity.start_date) }}</td>
                      <td><span class="type">{{ activity.type }}</span></td>
                      <td>{{ activity.total_duration }}</td>
                      <td>{{ activity.score }}%</td>
                      <td>{{ activity.outcome }}</td>
                      <td><span v-for="pair in pairCategories(activity)" :key="pair.name" class="category">{{ pair.name }}</span></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td>0/0/0000</td>
                      <td><span class="type">N/A</span></td>
                      <td>0 min</td>
                      <td>0%</td>
                      <td>N/A</td>
                      <td>N/A</td>
                    </tr>
                  </template>
                </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="info-card-wrapper">
        <div class="background-information-card">
          <div class="header">
            <h5>Background Information</h5>
            <button class="add-note" @click="toggleNote">
              Add Note
            </button>
          </div>
          <p><strong>Date of birth:</strong> {{ child.date_of_birth }}</p>
          <p><strong>Ethnicity:</strong> {{ child.ethnicity }}</p>
          <p><strong>Race:</strong> {{ child.race }}</p>
          <p><strong>Native language:</strong> {{ child.native_language }}</p>
          <p><strong>Organization:</strong> {{ child.organization }}</p>
          <div v-if="noteButton" class="note-text-box">
            <textarea
              v-model="message"
              placeholder="Add a note about the student!"
            ></textarea>
            <button @click="saveNote">Save</button>
          </div>

          <div v-else>
            <p>{{ child.specialist_note }}</p>
          </div>
        </div>
      </div>
    </div><!-- end v-else main content -->
  </div>
</template>


<script>
import LineChartGroupedECharts from './subComponents/LineChartGroupedECharts.vue';
import LineChartThreeECharts from './subComponents/LineChartThreeECharts.vue';
import BarChartEChart2 from './subComponents/BarChartECharts2.vue'
export default {
  name: 'SpecialistGoalsChildScreening',
  props: {
    childID: {
      type: String,
      required: true,
    },
    area: {
      type: String,
      default: null
    },
  },
  components:{
    LineChartGroupedECharts,
    LineChartThreeECharts,
    BarChartEChart2,
    //resizeChart,
  },
  data() {
    return {
      child: null,
      activeTab: 'screening',
      yearType: 'calendar',
      semesterType: null,
      analytics: null,
      noteButton: false,
      message: "",
      archivedSort: 'default',
      sideView: null,
      ieps: [],
      iepUploading: false,
      iepError: null,
    };
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    pairCategories(activity) {
      const names = activity.category.split(",").map(s => s.trim());
      const scores = activity.category_score.split(",").map(s => s.trim());

      return names.map((name, i) => ({
        name,
        score: scores[i] || ""
      }));
    },
    updateYearType(newType){
      if (newType) this.yearType = newType;
    },
    updateSemesterType(newType){
      if (newType) this.semesterType = newType;
    },
    toggleNote() {
      this.noteButton = true;
    },
    saveNote() {
      // update UI immediately
      this.noteButton = false;

      // call backend update here
      this.updateNote();
    },
    async updateNote() {
      console.log("Saving note:", this.message);

      const baseUrl =
        process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";

      try {
        const resp = await fetch(`${baseUrl}/api/child/${this.childID}/note`, {
          method: "PATCH", 
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            specialist_note: this.message, 
          }),
        });

        if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);

        const data = await resp.json();
        console.log("Update successful:", data);

      } catch (err) {
        console.error("Error updating note:", err);
      }

      await this.fetchData();
    },
    toggleSort(field) {
      if (this.archivedSort === field + "ASC") {
        this.archivedSort = field + "DSC";
      } else {
        this.archivedSort = field + "ASC";
      }

      this.fetchData();
    },
    async fetchIEPs() {
      const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";
      try {
        const resp = await fetch(`${baseUrl}/api/iep/${this.childID}`, { credentials: "include" });
        if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
        this.ieps = await resp.json() || [];
      } catch (err) {
        this.iepError = "Failed to load IEP documents.";
        console.error(err);
      }
    },
    async uploadIEP(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.iepUploading = true;
      this.iepError = null;
      const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";
      const form = new FormData();
      form.append("file", file);
      try {
        const resp = await fetch(`${baseUrl}/api/iep/${this.childID}`, {
          method: "POST",
          credentials: "include",
          body: form,
        });
        if (!resp.ok) {
          const body = await resp.text();
          throw new Error(`Upload failed (${resp.status}): ${body}`);
        }
        await this.fetchIEPs();
      } catch (err) {
        this.iepError = err.message;
        console.error(err);
      } finally {
        this.iepUploading = false;
        event.target.value = "";
      }
    },
    downloadCSV() {
      const esc = v => '"' + String(v || '').replace(/"/g, '""') + '"';
      const studentName = this.child ? `${this.child.first_name} ${this.child.last_name}` : '';
      const rows = [['Student', 'Document', 'Upload Date', 'Eligibility Category', 'Goal #', 'Goal Text']];
      this.ieps.forEach(iep => {
        if (iep.goals && iep.goals.length > 0) {
          iep.goals.forEach((goal, i) => {
            rows.push([studentName, iep.file_name, this.formatDate(iep.created_at), iep.eligibility_category || '', i + 1, goal]);
          });
        } else {
          rows.push([studentName, iep.file_name, this.formatDate(iep.created_at), iep.eligibility_category || '', '', '']);
        }
      });
      const csv = rows.map(r => r.map(esc).join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${studentName.replace(/\s+/g, '_')}_IEP_Goals.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
    async deleteIEP(iepID) {
      const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";
      try {
        const resp = await fetch(`${baseUrl}/api/iep/doc/${iepID}`, {
          method: "DELETE",
          credentials: "include",
        });
        if (!resp.ok) throw new Error(`Delete failed: ${resp.status}`);
        this.ieps = this.ieps.filter(i => i.iep_id !== iepID);
      } catch (err) {
        this.iepError = "Failed to delete IEP.";
        console.error(err);
      }
    },
    async fetchData() {
      try {
        const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";
        this.analytics = null;

        const resp = await fetch(`${baseUrl}/api/child/${this.childID}`, {
          credentials: "include",
        });

        if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);

        const data = await resp.json();

        const s = Array.isArray(data) ? data[0] : data;

        this.child = {
          child_id: s.child_id,
          first_name: s.first_name,
          last_name: s.last_name,
          phone_number: s.phone_number,
          email: s.email,
          preferred_name: s.preferred_name,
          organization: s.organization,
          site_name: s.site_name,
          date_of_birth: s.date_of_birth,
          cognitive_age: s.cognitive_age,
          biological_age: s.biological_age,
          profile_pic: s.profile_pic,
          race: s.race,
          ethnicity: s.ethnicity,
          grade: s.grade,
          specialist_note: s.specialist_note,
          native_language: s.native_language,
        };

        //fetching the individual child report data
        let classification = null

        if (this.activeTab === 'screening') {
        classification = 'Screening/Mini-Test'
        } else if (this.activeTab === 'assessments') {
        classification = 'Assessment/Test'
        } else if (this.activeTab === 'interventions') {
        classification = 'Intervention/Training/Lesson'
        }

        const query = new URLSearchParams({
          classification,
          yearType: this.yearType,
          semesterType: this.semesterType,
          archivedSort: this.archivedSort,
        });

        // Only add area if it exists
        if (this.area) query.append("area", this.area);

        const response = await fetch(
          `${baseUrl}/api/child/${this.childID}/individual-child-report?${query.toString()}`,
          { credentials: "include" } 
        );
        console.log("TAB:", this.activeTab);
        console.log("SORT:", this.archivedSort);
        console.log("REQUEST PARAMS:", {
        type: this.activeTab,
        sort: this.archivedSort
      });
        console.log(
          `${baseUrl}/api/child/${this.childID}/individual-child-report?${query.toString()}`
        );

        const dataAgain = await response.json();
        this.analytics = Array.isArray(dataAgain) ? dataAgain[0] : dataAgain;
        console.log("Fetched analytics report:", this.analytics);

      } catch (error) {
        console.error("Error fetching child:", error);
      }
    }
  },
  computed: {
    breakdownData() {
      if (
        !this.analytics ||
        !this.analytics.breakdown ||
        !this.analytics.breakdown.elements ||
        !this.analytics.breakdown.scores
      ) {
        return [];
      }

      const { elements, scores } = this.analytics.breakdown;

      return elements.map((el, i) => ({
        variable: el,
        value: Number(scores[i]) || 0
      }));
    }
  },
  watch:{
    // yearType() {
    //   this.fetchData();
    // },
    // area() {
    //   this.fetchData();
    // },
    // activeTab() {
    //   this.fetchData();
    // }
    activeTab: "fetchData",
    area: "fetchData",
    yearType: "fetchData",
    semesterType:"fetchData",
    archivedSort:"fetchData"
    //noteButton: "addNote
  },
  mounted(){
    this.updateYearType();
    this.updateSemesterType();
    //this.addNote();
    //this.toggleSort();
  }
};
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background: white;
}
.side-nav-fixed {
  position: fixed;
  top: 70px;
  left: 0;
  width: 15%;
  height: calc(100vh - 60px);
  background: #f4f4f4;
  padding: 24px;
  border-right: 1px solid #e5e5e5;
  font-size: 15px;
  color: #333;
  display: flex;
  flex-direction: column;

  a {
    text-decoration: none;
    color: #333;
    padding: 10px 0;
    transition: 0.2s;
  }
  .active-link {
    font-weight: bold;
    color: #9D5f0E;
  }
}
.side-nav-btn {
  background: none;
  border: none;
  text-align: left;
  font-size: 15px;
  color: #333;
  padding: 10px 0;
  cursor: pointer;
  transition: 0.2s;
  &.active-link {
    font-weight: bold;
    color: #9D5f0E;
  }
}
.iep-panel {
  padding: 32px;
  max-width: 860px;
}
.iep-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  h2 {
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 2px;
  }
}
.iep-patient-name {
  font-size: 26px;
  font-weight: 700;
  color: #111;
  margin: 0 0 16px;
}
.iep-header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}
.download-csv-btn {
  background: none;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #444;
  cursor: pointer;
  &:hover:not(:disabled) { border-color: #9D5f0E; color: #9D5f0E; background: #FFF5E3; }
  &:disabled { opacity: 0.4; cursor: default; }
}
.upload-btn {
  background-color: #FFF5E3;
  color: #9D5f0E;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
}
.iep-error {
  color: #c0392b;
  margin-bottom: 16px;
}
.iep-empty {
  color: #888;
  font-size: 14px;
  padding: 32px 0;
}
.iep-card {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.iep-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}
.iep-file-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  svg { margin-top: 2px; flex-shrink: 0; color: #9D5f0E; }
}
.iep-filename {
  font-weight: 600;
  margin: 0 0 2px;
  font-size: 14px;
}
.iep-date {
  color: #888;
  font-size: 12px;
  margin: 0;
}
.iep-delete-btn {
  background: none;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 13px;
  color: #c0392b;
  cursor: pointer;
  &:hover { background: #fff0f0; }
}
.iep-parsed {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-top: 1px solid #f0f0f0;
  padding-top: 14px;
}
.iep-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.iep-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
}
.iep-value {
  font-size: 14px;
  color: #333;
}
.iep-goal {
  display: flex;
  gap: 10px;
  font-size: 14px;
  color: #333;
  padding: 6px 0;
  border-bottom: 1px solid #f5f5f5;
  &:last-child { border-bottom: none; }
}
.goal-num {
  background: #FFF5E3;
  color: #9D5f0E;
  font-weight: 700;
  font-size: 12px;
  min-width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}

.specialist-goals-child-screening {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /*justify-content: center;*/
  padding: 40px;
  margin-left: 180px;
}
.top-section {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.left-info {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.child-card {
  background: white;
  padding: 32px;
  border-radius: 16px;
  border: 1px solid #eee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.row-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.profile-area {
  display: flex;
  align-items: center;
}
.circle {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  background: white;
  border: 3px solid #d89c29;
}
.child-info {
  margin-left: 18px;
  display: flex;
  flex-direction: column;
}
.child-info h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
}
.details {
  font-size: 14px;
  color: black;
  margin: 2px 0;
}
.actions {
  display: flex;
  gap: 12px;
  align-self: flex-start; 
  margin-left: auto; 
  margin-top: 130px;
}
.actions button {
  color: #9D5f0E;
  background: #FFF5E3;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
}
.actions button:hover {
  background: #ffe9c5;
}

.tabs {
  display: flex;
  gap: 10px;
  margin-top: 0px;
  border: 0.5px solid #ddd;
  border-radius: 8px;
  padding: 4px;
  height: 70px;
  width: 100%;
  margin-left: -1.1rem;
}
.tabs button {
  padding: 9px 18px;
  cursor: pointer;
  font-size: 14px;
  transition: 0.2s;
  border-radius: 8px;
  margin-top: 4px;
  margin-bottom: 8px;
}
.tabs button:hover {
  background: #f2f2f2;
}
.tabs .active {
  color: #9D5f0E;
  background-color: #FFF5E3;
  border-radius: 8px;
  font-weight: 600;
}
.sections {
  display: flex;
  justify-content: space-between;
  margin-top: 28px;
  gap: 20px;
}
.section {
  flex: 1;
  min-width: 0;
}
.section h3 {
  font-size: 16px;
  margin-bottom: 10px;
  color: black;
}
.right-top-section{
  display:flex;
  flex-direction: column;
}

.tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.strength-tag {
  padding: 6px 12px;
  background: #FFF5E3;
  border: 1px solid #f3b944;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  color:#9D5f0E
}
.focus-tag {
  padding: 6px 12px;
  background: #ffebeb;
  border: 1px solid #ec6060;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  color: #404b52;
}
.assessment-card {
  border: none;
  max-width: 900px;
  width: 100%;
}
.intervention-card {
  border: none;
  max-width: 900px;
  width: 100%;
}
.screening-card {
  border: none;
  max-width: 900px;
  width: 100%;
}

.stat-card {
  padding: 16px;
  border-radius: 12px;
  margin-top: 20px;
  max-width: 932px;
  width: 100%;
  margin-left: none;
  margin-right: none;
  border: none;
}
.screening-grid, .assesment-grid, .intervention-grid {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}
.screening-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sort-by{
  display: flex;
  align-items: center;
  color: #9D5f0E;
  background: #FFF5E3;
  border-radius: 8px;
  padding: 4px 10px;
  gap: 6px;
  width: fit-content;

  label {
    font-size: 16px;
    color: gray;
    margin: 0;
  }
  select {
    appearance: none; 
    border: none;
    color: #9D5f0E;
    background: #FFF5E3;
    font-size: 16px;
    padding: 6px 24px 6px 0;
    cursor: pointer;
    outline: none;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' stroke='%239D5f0E' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 8l4 4 4-4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 4px center;
    background-size: 16px 16px;
  }
}
.mini-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  border: 1px solid #eee;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-height: 160px;
  display: flex;
  flex-direction: column;
}
.mini-card h3 {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: black;
}
.pill-toggle, .semester-row{
  display: flex;
  padding: 4px;
  border: none;

  button {
    background: none;
    border: 1px solid black;
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 13px;
    cursor: pointer;
    color: black;
    justify-content: space-between;

    &.active {
      background: black;
      color: white;
      font-weight: 600;
    }
  }
}
.legend{
  display: flex;
  color: black;
  justify-content: right;
  font-size: 12px;
  padding-right: 4px;
  padding-left: 4px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px 40px;
  margin-top: 20px;
}

.stat-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.icon-box {
  min-width: 45px;
  height: 45px;
  background: #f3f4f6;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: black;
}

.stat-label {
  font-size: 12px;
  color: #444;
}
.label {
  font-size: 12px;
  color: #444;
  justify-content: center;
}
.stat-subtext {
  font-size: 12px;
  color: #777;
}

.stat-subtext.positive {
  color: #16a34a;
  font-weight: 500;
}

.stat-subtext.link {
  color: #2563eb;
  font-weight: 500;
}

.progress-over-time{
  flex: 1;
  margin-top: 1%;
}
.breakdown-container{
  height: 100%;
  justify-content: center;
}
.tag-row{
  display: flex;
  align-items: center;
  flex-direction: row;
}
.tag-column-1, .tag-column-2, .tag-column-3, .tag-column-4{
  display: flex;
  align-items: center;
  flex-direction: column;
}
.shift-up{
  display: flex;
  height: 70%;
  width: 70%;
  margin-top: -30px;
}
.shift-down{
  display: flex;
  height: 70%;
  width: 70%;
}
.stacked-text{
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: left;
  padding-right: 2px;
}
.mini-mini-card{
  font-size: 10px;
  color: black;
  justify-content: left;
  padding-right: 2px;
  .number{
    font-size: 12px;
    font-weight: 600;
    justify-content: left;
    padding-right: 2px;
  }
  .small-text{
    font-size:8px;
    justify-content: left;
    padding-right: 2px;
    padding-bottom: 2px;
  }
}

.activity-information-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  border: 1px solid #eee;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-height: 160px;
  display: flex;
  flex-direction: column;
  max-width: 900px;
  width: 100%;
  margin-left: none;
  margin-right: none;
  border: none;
}
.activity-information-card h4 {
  font-size: 20px;
  font-weight: 600;
  color: black;
}
.background-information-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  border: 1px solid #eee;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-height: 160px;
  display: flex;
  flex-direction: column;
  max-width: 900px;
  width: 100%;
  margin-left: none;
  margin-right: none;
  border: none;
}
.header{
  flex: 1;
  border:none;
}
.add-note{
border: 1px solid #9D5f0E;
color: #9D5f0E;
padding: 6px 12px;
border-radius: 4px;
}
.add-note:hover{
    border: 1px solid #9D5f0E;
    color: #9D5f0E;
    background: #FFF5E3;
  }
  .add-note .active{
    border: 1px solid #9D5f0E;
    color: #9D5f0E;
    background: #FFF5E3;
  }
.background-information-card h5 {
  font-size: 16px;
  font-weight: 600;
  color: black;
  justify-content: left;
  margin: 0 0px;
}
.background-information-card p {
  font-size: 14px;
  color: black;
  margin: 0 0px;
  padding-top: 1px;
}
.info-card-wrapper {
  margin-top: 10px;
  max-width: 932px;
  width: 100%;
  padding: 16px
}
.activity-scroll {
  max-height: 200px;
  overflow-y: auto;
  border: none;
  border-top: none;
}
.activity-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;

  th,
  td, tr, ts {
    padding: 0.75rem;
    border-bottom: 1px solid #ccc;  
    text-align: center;
  }
  thead {
    position: relative; 
    font-size: 14px;
    color: black;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;      
        left: 50%;      
        transform: translateX(-50%);
        width: 104%; 
        border-bottom: 1px solid black;
        pointer-events: none;  
    }
    th {
        border-bottom: none;  
        font-weight: 400;
    }
  }
  tbody {
    font-weight: 400;
    font-size: 14px;
  }
}
.category,
.type {
  display: inline-block;
}

.category {
  padding: 2px 10px;
  background: #ffebeb;
  border: 1px solid #ec6060;
  border-radius: 999px;
  color: #404b52;
}

.type {
  padding: 6px 12px;
  background: #FFF5E3;
  border: 1px solid #f3b944;
  border-radius: 999px;
  color: #9D5f0E;
}
.note-text-box{
  border:#777;
  margin-top: 8px;
  width:100%;
  display: flex;
  flex-direction: column;
}
</style>